'use strict';

import $ from 'jquery';
import { queryString, redirectWithParams } from '@/js/modules/query_params';
import { INLINE_SELECTIZE } from '@/js/modules/selectize_plugins';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  const PRICE_RANGE_MAP = {
    'Under 100': '0-100',
    '100 to 250': '100-250',
    '250 to 500': '250-500',
    '500 to 750': '500-750',
    '750 to 1000': '750-1000',
    '1000 to 2000': '1000-2000',
    '2000 or more': '2000+',
  };

  const FILTERS = [
    'price[]',
    'item_category_ids[]',
    'project_ids',
    'vendor',
    'tags',
    'approved_shoppables',
    'board_id',
  ];

  $(document).ready(function () {
    // render labels when ready
    renderFilterLabels();

    // filter drop downs with a selectized field on top
    [...document.querySelectorAll('.filter-dropdown__field--search-selectized')]
      .filter(
        ({ classList }) =>
          // Prevent initializing selectize more than once on the same element.
          !classList.contains('filter-dropdown__field--swatch-vendor') &&
          !classList.contains('filter-dropdown__field--swatch-approval-state')
      )
      .map((e) => $(e))
      .forEach((e) => {
        // $('.filter-dropdown__field--search-selectized')
        e.selectize({
          plugins: [INLINE_SELECTIZE],
          persist: false,
          render: {
            item(data, escape) {
              return `<div class="field__tag-item">${escape(data.text)}</div>`;
            },
          },
        }).on('change', function (e) {
          const $filterElement = $(e.currentTarget);

          // only apply filter when user manually selects the filter and not when "enter" key is pressed
          // on the page randomly
          if (!$filterElement.parents('.filter-list__item').hasClass('filter-list__item--open')) {
            this.selectize && this.selectize.clear();
            return false;
          }

          const params = queryString();
          const param = $filterElement.data('param');
          params[param] = $filterElement.val();

          if (!params[param]) {
            return false;
          }
          if (params[param] === 'all') {
            delete params[param];
          }
          redirectWithParams(Object.assign(params, { view_context: 'tasks' }));
        });
      });

    // trigger on click
    $(document.body).on('click', '.filter-list__dropdown-trigger', function (e) {
      e.preventDefault();

      $('.filter-list__item')
        .not($(this).parent('.filter-list__item'))
        .removeClass('filter-list__item--open');

      const parentClass = $(this)
        .parent('.filter-list__item')
        .toggleClass('filter-list__item--open');
      $(parentClass.find('input')[0]).focus();
    });

    // click on outside
    $('#library').on('click', (e) => {
      const $dropdown = $(e.target).closest('.filter-list__item');
      if (!$dropdown.length && $('.filter-list__item').hasClass('filter-list__item--open')) {
        $('.filter-list__item').removeClass('filter-list__item--open');
      }
    });

    // on click on done(submit)
    $('.s-button--submit-filter-dropdown-price').on('click', (e) => {
      const params = queryString();
      const priceRanges = $('.checkbox--filter-dropdown-price:checked').map((index, item) =>
        $(item).val()
      );
      params['price[]'] = Array.from(priceRanges);
      redirectWithParams(params);
    });

    // on click on done(submit)
    $('.s-button--submit-filter-dropdown-item-category').on('click', (e) => {
      const params = queryString();
      const itemCategories = $('.checkbox--filter-dropdown-item-category:checked').map(
        (index, item) => $(item).val()
      );
      params['item_category_ids[]'] = Array.from(itemCategories);
      redirectWithParams(params);
    });

    // clear all filters
    $(document).on('click', '.filter-labels__item--clear', () => {
      const params = queryString();
      FILTERS.map((filter) => delete params[filter]);
      redirectWithParams(params);
    });

    $(document).on('click', '.filter-dropdown__item--sort-by', (e) => {
      const sortBy = $(e.target).data().sortBy;
      const params = queryString();
      if (sortBy === 'recency' || sortBy === 'relevance') {
        params['sort_by'] = sortBy;
      }

      redirectWithParams(params);
    });

    $(document).on('filter-dropdown:apply', ({ detail, target }) => {
      const { filters } = detail;
      const filterBy = filters[0];

      $(target)
        .closest('.modal')
        .find('[data-vendor-name]')
        .each((_index, node) => {
          const $node = $(node);
          const nodeValue = $node.data('vendor-name');

          if (nodeValue === filterBy || filterBy.length === 0) {
            $node.removeClass('hide');
          } else {
            $node.addClass('hide');
          }
        });
    });

    // clear a filter
    $(document).on('click', '.filter-labels__item--remove', (e) => {
      const param = $(e.currentTarget).data('param');
      const value = $(e.currentTarget).data('value');
      const params = queryString();
      // if string just delete the key, if array delete the value inside array
      if (typeof params[param] === 'string') {
        delete params[param];
      } else {
        const index = params[param].indexOf(value.toString());
        if (index > -1) {
          params[param].splice(index, 1);
        }
      }

      redirectWithParams(params);
    });

    // on submitting search query (q)
    $('.header-controls__search-field-container')
      .closest('form')
      .submit((e) => {
        e.preventDefault();
        const params = queryString();
        params['q'] = $(e.target).find('.search-field').val();
        redirectWithParams(params);
      });

    /**
     * render price filter labels
     * @return {String} - price labels as html strings
     */
    function renderPriceFilterLabels() {
      const currencySymbol = $('meta[name="currency-symbol"]').attr('content');
      let priceRanges = queryString()['price[]'] || [];

      if (priceRanges.length > 0) {
        $('.checkbox--filter-dropdown-price:checked').each(
          (index, item) => priceRanges << $(item).val()
        );
      }

      if (Array.isArray(priceRanges)) {
        priceRanges = Array.from(priceRanges);
      } else {
        if (priceRanges) {
          priceRanges = Array.from([priceRanges]);
        }
      }

      return priceRanges
        .map(
          (price) =>
            `<a class="filter-labels__item filter-labels__item--remove" data-value="${price}" data-param="price[]">${currencySymbol}${
              PRICE_RANGE_MAP[price.replace(/\+/g, ' ')]
            }</a>`
        )
        .join('');
    }

    /**
     * render project filter labels
     * @return {String} - Project labels as html strings
     */
    function renderProjectFilterLabels() {
      const projectElement = document.querySelector('#project.filter-dropdown__select-ajax');
      if (!projectElement) {
        return;
      }

      const fieldValue = projectElement.dataset.value;
      const fieldName = projectElement.dataset.name;

      if (fieldValue === undefined || fieldValue === '') {
        return [];
      }

      if (fieldName === undefined || fieldName === '') {
        return [];
      }

      const projectIds = JSON.parse([fieldValue].flat());
      const projectNames = JSON.parse([fieldName].flat());

      return projectIds
        .map((projectId, index) => {
          const projectName = projectNames[index];
          if (!projectName) {
            return null;
          }
          return `<a class="filter-labels__item filter-labels__item--remove" data-value="${projectId}" data-param="project_ids">${projectName}</a>`;
        })
        .join('');
    }

    /**
     * render vendor filter labels
     * @return {String} - Vendor labels as html strings
     */
    function renderVendorFilterLabels() {
      const vendorElement = $('#vendor.filter-dropdown__select-ajax');
      const fieldValue = vendorElement.data('value');

      if (fieldValue === undefined || fieldValue === '') {
        return [];
      }

      return vendorElement
        .toArray()
        .map((vendorField) => {
          const dataValue = vendorField.getAttribute('data-value').replace(/[']/gim, "\\'");
          return `<a class="filter-labels__item filter-labels__item--remove" data-value="${dataValue}" data-param="vendor">${dataValue}</a>`;
        })
        .join('');
    }

    /**
     * render tags filter labels
     * @return {String} - Tag labels as html strings
     */
    function renderTagsFilterLabels() {
      // if field is empty, don't bother
      const fieldValue = $('.filter-dropdown__field--tags').data('value');
      if (fieldValue === undefined || fieldValue === '') {
        return [];
      }
      return $('.filter-dropdown__field--tags')
        .toArray()
        .map((tagField) => {
          const dataValue = tagField.getAttribute('data-value').replace(/[']/gim, "\\'");
          const tagName = $(tagField).find(`option[value='${dataValue}']`).text();
          return `<a class="filter-labels__item filter-labels__item--remove" data-value="${dataValue}" data-param="tags">${tagName}</a>`;
        })
        .join('');
    }

    function renderApprovedFilterLables() {
      // if field is empty, don't bother
      const fieldValue = $('.filter-dropdown__field--approved-shoppables').data('value');
      if (fieldValue === undefined || fieldValue === '') {
        return [];
      }
      return $('.filter-dropdown__field--approved-shoppables')
        .toArray()
        .map((approvedField) => {
          // converts strings like "'approved' name" to "\\'approved\\' name"
          // to allow jQuery to make searches like `value='\'approved\' name'`
          const dataValue = approvedField.getAttribute('data-value').replace(/[']/gim, "\\'");
          const approvedProducts = $(approvedField).find(`option[value='${dataValue}']`).text();
          return `<a class="filter-labels__item filter-labels__item--remove" data-value="${dataValue}" data-param="approved_shoppables">${approvedProducts}</a>`;
        })
        .join('');
    }

    function renderBoardFilterLables() {
      // if field is empty, don't bother
      const fieldValue = $('.filter-dropdown__field--board_id').data('value');
      if (fieldValue === undefined || fieldValue === '') {
        return [];
      }
      return $('.filter-dropdown__field--board_id')
        .toArray()
        .map((boardField) => {
          // converts "example 'board' name" to "example \\'board\\' name"
          // to allow jQuery to make searches like `value='\'board\' name'`
          const dataValue = boardField.getAttribute('data-value').replace(/[']/gim, "\\'");
          const boardName = $(boardField).find(`option[value='${dataValue}']`).text();
          return `<a class="filter-labels__item filter-labels__item--remove" data-value="${dataValue}" data-param="board_id">${boardName}</a>`;
        })
        .join('');
    }
    /**
     * render item categories filter labels
     * @return {String} - item category labels as html strings
     */
    function renderItemCategoriesFilterLabels() {
      const itemCategoryIds = queryString()['item_category_ids[]'] || [];
      let itemCategories = [];
      if (itemCategoryIds.length > 0) {
        itemCategories = $.map(
          $('.checkbox--filter-dropdown-item-category:checked'),
          (itemCategory) => {
            return {
              label: $('label[for="' + itemCategory.id + '"]').html(),
              id: $(itemCategory).val(),
            };
          }
        );
      }

      return itemCategories
        .map(
          (itemCategory) =>
            `<a class="filter-labels__item filter-labels__item--remove" data-value="${itemCategory.id}" data-param="item_category_ids[]">${itemCategory.label}</a>`
        )
        .join('');
    }

    /**
     * render all filter labels
     * currently price and project labels
     */
    function renderFilterLabels() {
      // collect labels
      const priceLabels = renderPriceFilterLabels();
      const projectLabel = renderProjectFilterLabels();
      const vendorLabel = renderVendorFilterLabels();
      const tagsLabel = renderTagsFilterLabels();
      const approvedLabel = renderApprovedFilterLables();
      const boardLabel = renderBoardFilterLables();
      const itemCategoriesLabel = renderItemCategoriesFilterLabels();
      let filterLabels = [
        priceLabels,
        projectLabel,
        vendorLabel,
        tagsLabel,
        approvedLabel,
        boardLabel,
        itemCategoriesLabel,
      ].join('');
      const hasFilters = filterLabels !== '';

      $('.filter-labels').html('');
      $('.shoppables .data-table--shoppables').toggleClass('has-filters', hasFilters);

      if (hasFilters) {
        filterLabels = `${filterLabels}<a class="filter-labels__item filter-labels__item--clear">Clear All</a>`;
        $('.filter-labels').html(filterLabels);
      }
    }

    // remove highlight if search value is empty
    // add clear(x) when search value is not empty
    $('.selectize-input input').on('keyup', (e) => {
      const selectizeControl = $(e.target).parents('.selectize-control');
      const clearSearch = selectizeControl.find('.selectize-control--clear-search');
      const selectizedCategory = $(e.target).parents('.selectized-category');

      if ($(e.target).val() === '') {
        // highlight issue is being fixed
        // github issue https://github.com/selectize/selectize.js/issues/1149
        // TODO: update selectize version when fix is ready
        selectizeControl.find('.highlight').removeClass('highlight');

        clearSearch.remove();
      } else {
        if (clearSearch.length === 0 && selectizedCategory.length === 0) {
          $(
            '<a class="selectize-control--clear-search" href="#"><i class="fa-solid fa-circle-xmark"></i></a>'
          ).insertAfter($(e.target));
        }
      }
    });

    // clear search box
    $('.selectize-input').on('click', '.selectize-control--clear-search', (e) => {
      e.preventDefault();
      e.stopPropagation();

      const $input = $(e.target).closest('.selectize-control').find('.selectize-input input');

      $input.trigger('keyup');
      $input.blur();
    });
  });
});
